import {
    Grid, Table, TableBody, TableContainer, TableHead, TablePagination,
    TableSortLabel, Typography
} from '@mui/material';
import moment from 'moment';
import React from 'react';
import { UploadUpdateAPIProps } from '../../models/APITransationLog/IAPITransationLog';
import { useGlobalState } from '../../store/GlobalStore';
import Footer from '../Footer/Footer';
import StyledCell from '../GlobalStyles/StyledCell';
import StyledTableRow from '../GlobalStyles/StyledTableRow';
import { StyledTableCell } from '../GlobalStyles/TableStyledCell';
import { useRowStyles } from './APITransactionLogCss';
import ViewMoreUpdateAPI from './ViewMoreUpdateAPI';

const UploadUpdateAPI: React.FC<UploadUpdateAPIProps> = ({ uploadUpdateAPILogList, totalUpdateAPICount, page, rowsPerPage, order, orderBy, onSortChange, onPageChange, onRowsPerPageChange }) => {
    const classes = useRowStyles();
    const { state } = useGlobalState();

    const handleSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        onSortChange(property, newOrder);
    };

    const headCells = [
        { id: "clientNo", label: "CLIENT CODE" },
        { id: "clT_NAME_1", label: "CLIENT NAME" },
        { id: "dbtNumber", label: "DEBTOR NUMBER" },
        { id: 'account_no', label: 'ACCOUNT NO' },
        { id: "transactionAmount", label: "TRANSACTION AMOUNT" },
        { id: "transactionDate", label: "TRANSACTION DATE" },
        { id: "phase", label: "PHASE" },
        { id: "accountBalance", label: "ACCOUNT BALANCE" },
        { id: "recordType", label: "RECORD TYPE" },
        { id: "transactionId", label: "TRANSACTIONID" },
        { id: "invoiceNumber", label: "INVOICE NUMBER" },
        { id: "createdDate", label: "CREATED DATE", },
        { id: "actions", label: "ACTIONS" },
    ];

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <TableContainer className={`${classes.tableBody} scrollbox on-scrollbar`}>
                    <Table stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                {headCells.map((headCell) => (
                                    <StyledTableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} className={classes.tableHeaderStyle} >
                                        {headCell.id !== 'actions' ? (
                                            <TableSortLabel
                                                active={orderBy === headCell.id}
                                                direction={orderBy === headCell.id ? order : 'asc'}
                                                onClick={() => handleSort(headCell.id)}
                                            >
                                                {headCell.label}
                                            </TableSortLabel>
                                        ) : (
                                            headCell.label
                                        )}
                                    </StyledTableCell>
                                ))}
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {uploadUpdateAPILogList?.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledCell className={classes.tableCellBody}>{row?.clientNo ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.clT_NAME_1 ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.dbtNumber ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.accountNumber ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {(row?.transactionAmount ?? null) !== null ? row?.transactionAmount.toFixed(2) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.transactionDate ? moment(row?.transactionDate).format(state.GlobalUtils?.settingValue) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.phase ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.accountBalance !== undefined && row?.accountBalance !== null ? row?.accountBalance.toFixed(2) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.recordType ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.transactionId ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>{row?.invoiceNumber ?? ''}</StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        {row?.updateDate ? moment(row?.updateDate).format(state.GlobalUtils?.settingValue) : ''}
                                    </StyledCell>
                                    <StyledCell className={classes.tableCellBody}>
                                        <ViewMoreUpdateAPI row={row} />
                                    </StyledCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {uploadUpdateAPILogList?.length === 0 ?
                        <Typography variant="h6" fontSize={15} color={'red'} gutterBottom marginTop={1}>
                            No records to display..
                        </Typography>
                        : null}
                </TableContainer>
            </Grid>

            <Grid container spacing={0}>
                <Grid item xs={6} sm={6}>
                    <div className="footer">
                        <Footer />
                    </div>
                </Grid>
                <Grid item xs={6} sm={5}>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[25, 50, 100]}
                        count={totalUpdateAPICount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={(event, newPage) => onPageChange(newPage)}
                        onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UploadUpdateAPI;
